module.exports = __webpack_public_path__ + "img/1-5.397be5d7.png";